import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-help.report',
  imports: [],
  templateUrl: './help.report.component.html',
  styleUrl: './help.report.component.scss'
})
export class HelpReportComponent implements OnInit {

  selectedSection = 'reports';

  constructor(
    private navigationService: HelpNavigationService
  ) { }

  ngOnInit(): void {

    this.navigationService.selectedSection.next('reports');

    this.navigationService.selectedSection.subscribe(section => {

      this.selectedSection = section;

      setTimeout(() => {

        const element = document.getElementById(section);

        const container =
          document.querySelector('.help-content') as HTMLElement;

        if (element && container) {

          container.scrollTo({
            top: element.offsetTop - 40,
            behavior: 'smooth'
          });

        }

      }, 50);

    });

  }

  changeSection(section: string): void {

    this.navigationService.selectedSection.next(section);

  }
}
